export interface Project {
  id: string;
  title: string;
  description: string;
  techStack: string[];
  liveUrl?: string;
  repoUrl?: string;
  featured: boolean;
}

export const projects: Project[] = [
  {
    id: "proj-1",
    title: "Portfolio Website",
    description: "Personal portfolio with terminal aesthetic, GSAP animations, and data-driven content. Built as a learning project to explore modern frontend techniques.",
    techStack: ["React", "TypeScript", "Tailwind CSS", "GSAP", "Vite"],
    repoUrl: "https://github.com/khang",
    featured: true,
  },
  {
    id: "proj-2",
    title: "Task Management API",
    description: "RESTful API with authentication, real-time updates via WebSockets, and comprehensive test coverage. Designed for scalability and clean architecture.",
    techStack: ["Node.js", "Express", "PostgreSQL", "Redis", "Docker"],
    repoUrl: "https://github.com/khang",
    featured: true,
  },
  {
    id: "proj-3",
    title: "Data Pipeline Framework",
    description: "Configurable ETL pipeline that processes and transforms data from multiple sources. Features retry logic, monitoring, and alerting.",
    techStack: ["Python", "Celery", "RabbitMQ", "PostgreSQL"],
    repoUrl: "https://github.com/khang",
    featured: false,
  },
  {
    id: "proj-4",
    title: "CLI Dev Tools",
    description: "Collection of command-line utilities for automating common development tasks like project scaffolding, database migrations, and log analysis.",
    techStack: ["Rust", "SQLite", "Shell"],
    repoUrl: "https://github.com/khang",
    featured: false,
  },
];
